// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2MfuR","image":"Header_image__1Y36D","name":"Header_name__zJfne","info":"Header_info__1Ke28","infoRow":"Header_infoRow__1Ak84"};